import React from 'react';

const ShortTermResultsTable = ({ results, onTradeClick, onChartClick }) => {
  if (!results || results.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        <p>No stocks found matching your criteria.</p>
        <p className="text-sm mt-2">Try adjusting your filter parameters.</p>
      </div>
    );
  }

  const formatNumber = (value, decimals = 2) => {
    if (value === null || value === undefined) return '-';
    return Number(value).toFixed(decimals);
  };

  const formatPercent = (value) => {
    if (value === null || value === undefined) return '-';
    const num = Number(value);
    const color = num >= 0 ? 'text-green-600' : 'text-red-600';
    const arrow = num >= 0 ? '▲' : '▼';
    return (
      <span className={color}>
        {arrow} {Math.abs(num).toFixed(2)}%
      </span>
    );
  };

  const formatVolume = (value) => {
    if (value === null || value === undefined) return '-';
    const num = Number(value);
    if (num >= 1000000) {
      return `${(num / 1000000).toFixed(1)}M`;
    } else if (num >= 1000) {
      return `${(num / 1000).toFixed(1)}K`;
    }
    return num.toString();
  };

  return (
    <div className="overflow-x-auto shadow-md rounded-lg">
      <table className="min-w-full bg-white">
        <thead className="bg-gradient-to-r from-green-600 to-blue-600 text-white">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">
              Symbol
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">
              Action
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider">
              Close
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider">
              % Change
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider">
              ADX
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider">
              RSI
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider">
              MA20
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider">
              MA50
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider">
              Volume
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider">
              Vol Ratio
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider">
              RS-55
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {results.map((stock, index) => (
            <tr
              key={`${stock.Symbol}-${index}`}
              className="hover:bg-gray-50 transition-colors"
            >
              <td className="px-6 py-4 whitespace-nowrap">
                <button
                  onClick={() => onChartClick && onChartClick(stock.Symbol)}
                  className="text-blue-600 hover:text-blue-800 font-semibold hover:underline cursor-pointer"
                  title="Click to view chart"
                >
                  {stock.Symbol}
                </button>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <button
                  onClick={() => onTradeClick(stock.Symbol)}
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors font-medium"
                >
                  Trade
                </button>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-gray-900">
                ₹{formatNumber(stock.Close)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right">
                {formatPercent(stock['% Change'])}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-gray-900">
                {formatNumber(stock.ADX, 1)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-gray-900">
                {formatNumber(stock.RSI, 1)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-gray-900">
                ₹{formatNumber(stock.MA20)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-gray-900">
                ₹{formatNumber(stock.MA50)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-gray-900">
                {formatVolume(stock.Volume)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-gray-900">
                {formatNumber(stock.Vol_Ratio)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-gray-900">
                {formatNumber(stock.RS_55)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ShortTermResultsTable;

